import React, {FC} from 'react';
import {connect} from 'react-redux';

import {TeammateModel} from '../../../libs/shared/core/src/models/api/teammateModel';
import {getIsUserGlobalAdmin} from '../../../libs/shared/core/src/store/data/access/commonAccessSelectors';
import {ViewerPanelId} from '../../../libs/shared/core/src/store/panels/panelStateBase';
import {makeMapStateToProps} from '../../../srcCommon/helpers/reselectHelpers';
import {FrameViewerState} from '../../../srcCommon/inboxes/side/sideFrameActions';
import {SidePanelTrackingPayload} from '../../helpers/sidePanelTrackingHelpers';
import {IntegrationModel} from '../../models/api/integrationModel';
import {getUser} from '../../store/data/teammates/teammatesSelectors';
import {AppEntrypointLegacySdkComponent} from './appEntryPointLegacySdkComponent';
import {serializeIntegrationWithPluginToApplicationModel} from './legacySdkPluginIntegrationHelpers';

/*
 * Props.
 */

export interface LegacySdkPluginIntegrationContainerProps {
  panelId: ViewerPanelId;
  trackingPayload?: SidePanelTrackingPayload;
  onRequestWidthChange: (arg: number) => void;
  isVisible: boolean;
  integration: IntegrationModel;
  viewerState?: FrameViewerState;
}

interface LegacySdkPluginIntegrationContainerComponentProps extends LegacySdkPluginIntegrationContainerProps {
  user: TeammateModel;
  isUserGlobalAdmin: boolean;
}

const LegacySdkPluginIntegrationContainerComponent: FC<LegacySdkPluginIntegrationContainerComponentProps> = (
  props,
) => {
  const {
    panelId,
    trackingPayload,
    onRequestWidthChange,
    isVisible,
    integration,
    user,
    isUserGlobalAdmin,
    viewerState,
  } = props;

  // This is not a persisted application, but an application model we converted from an integration model.
  const serializedApplicationModel = serializeIntegrationWithPluginToApplicationModel(integration);

  if (!serializedApplicationModel) {
    return null;
  }

  const entryPoint =
    serializedApplicationModel.entryPoints && serializedApplicationModel.entryPoints.length > 0
      ? serializedApplicationModel.entryPoints[0]
      : undefined;

  if (!entryPoint) {
    return null;
  }

  return (
    <AppEntrypointLegacySdkComponent
      entryPoint={entryPoint}
      application={serializedApplicationModel}
      panelId={panelId}
      isVisible={isVisible}
      onRequestWidthChange={onRequestWidthChange}
      trackingPayload={trackingPayload}
      user={user}
      isUserGlobalAdmin={isUserGlobalAdmin}
      viewerState={viewerState}
    />
  );
};

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<LegacySdkPluginIntegrationContainerProps>()(() => ({
  user: getUser,
  isUserGlobalAdmin: getIsUserGlobalAdmin,
}));

export const LegacySdkPluginIntegrationContainer = connect(mapStateToProps)(
  LegacySdkPluginIntegrationContainerComponent,
);
